const mapperToOptions = (
    options,
    id = 'id',
    title = 'title',
    isDefault = 'is_default',
    isCalculated = 'is_calculated',
    icon = 'icon',
    color = 'color',
    status = 'status',
    startDate = 'start_date',
    endDate = 'end_date',
    description = 'description'
) => {
    return options.map(option => {
        return {
            value: option[id],
            label: option[title],
            isDefault: option[isDefault],
            isCalculated: option[isCalculated],
            icon: option[icon] || '',
            color: option[color] || { hex: '', title: '' },
            status: option[status] || '',
            startDate: option[startDate] || '',
            endDate: option[endDate] || '',
            description: option[description] || '',
        }
    })
}

export { mapperToOptions }
